import { FIREBASE_API_KEY, FIREBASE_AUTH_DOMAIN } from 'configs';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, OAuthProvider, signInWithPopup, getRedirectResult } from 'firebase/auth';

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new OAuthProvider('microsoft.com');
const redirectResult = getRedirectResult(auth);

export { auth, signInWithEmailAndPassword, provider, signInWithPopup, OAuthProvider, redirectResult };
